import { render, staticRenderFns } from "./DashboardNewInfo.vue?vue&type=template&id=7cabcdd1"
import script from "./DashboardNewInfo.vue?vue&type=script&lang=js"
export * from "./DashboardNewInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports